import React from "react";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { MdAddCircle, MdRemoveCircle } from "react-icons/md";
import styles from "./BonusTransactionItem.module.scss";
import { BonusTransaction } from "../../../../common/types/types";
import { useTheme } from "../../../../common/hooks/useTheme";
import { BonusTransactionType } from "../../../../common/types/enums";

interface BonusTransactionItemProps {
  transaction: BonusTransaction;
}

export default function BonusTransactionItem({ transaction }: BonusTransactionItemProps) {
  const { theme } = useTheme();
  const isEarned = transaction.type === BonusTransactionType.EARNED;

  const Icon = isEarned ? MdAddCircle : MdRemoveCircle;
  const earnedColor = "#4CAF50";
  const spentColor = "#F44336";
  const iconColor = isEarned ? earnedColor : spentColor;
  const sign = isEarned ? "+" : "-";

  const date = format(new Date(transaction.createdAt), "dd.MM.yyyy HH:mm", { locale: ru });

  return (
    <div className={styles.container} style={{ backgroundColor: theme.card, borderColor: theme.border }}>
      <div className={styles.iconContainer} style={{ backgroundColor: `${iconColor}20` }}>
        <Icon size={20} color={iconColor} />
      </div>
      <div className={styles.info}>
        <span className={styles.description} style={{ color: theme.text }}>
          {transaction.description}
        </span>
        <div className={styles.meta}>
          {transaction.orderId && (
            <span className={styles.orderId} style={{ color: theme.textSecondary }}>
              №{transaction.orderId}
            </span>
          )}
          <span className={styles.date} style={{ color: theme.textSecondary }}>
            {date}
          </span>
          {transaction.balanceSnapshot !== undefined && (
            <span className={styles.balance} style={{ color: theme.textSecondary }}>
              {transaction.balanceSnapshot} ₽
            </span>
          )}
        </div>
      </div>
      <span className={styles.amount} style={{ color: iconColor }}>
        {sign}
        {transaction.amount}
      </span>
    </div>
  );
}